export { initCookiesBlocker, onCookiesAccepted, closeCookiesBanner } from './service'
